module.exports = "/_next/static/images/search_bg_11-8f0f5500a8fbc8cf13685dda040e4d59.jpg";